module.exports = __webpack_public_path__ + "img/philippe-logo.25790859.webp";